import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const SharedAreaQuerySchema = z.object({
  chatIds: z.union([
    z.string().transform((value) => value.split(',')),
    z.array(z.string()),
  ]),
  publicTokens: z.union([
    z.string().transform((value) => value.split(',')),
    z.array(z.string()),
  ]),
});

export const Route = createFileRoute('/shared-arena')({
  validateSearch: SharedAreaQuerySchema.parse,
});
